<div class="p-fluid space-y-3" [formGroup]="formGroup">
    <div class="flex flex-col gap-1">
        <label for="ancillary-key">Service Key</label>
        <input
            id="ancillary-key"
            pInputText
            formControlName="ancillaryKey"
            placeholder="Ancillary Key"
            class="w-full"
            maxlength="255"
            [ngClass]="{
                'ng-dirty': submitted && formGroup.get('ancillaryKey')?.invalid,
                'ng-invalid': submitted && formGroup.get('ancillaryKey')?.invalid
            }"
        />
        <small *ngIf="submitted && formGroup.get('ancillaryKey')?.hasError('required')" class="text-red-500"
            >Ancillary Key is required.</small
        >
        <small *ngIf="submitted && formGroup.get('ancillaryKey')?.hasError('maxlength')" class="text-red-500">Max 255 characters.</small>
    </div>
    <div class="flex flex-col gap-1">
        <label for="provider-select">Select Provider</label>
        <p-select
            inputId="provider-select"
            [options]="providers"
            optionLabel="explanation"
            optionValue="code"
            appendTo="body"
            formControlName="providerCode"
            placeholder="Select Provider"
            [disabled]="mode === 'edit'"
            class="w-full"
            [ngClass]="{
                'ng-dirty': submitted && formGroup.get('providerCode')?.invalid,
                'ng-invalid': submitted && formGroup.get('providerCode')?.invalid
            }"
        />
        <small *ngIf="submitted && formGroup.get('providerCode')?.hasError('required')" class="text-red-500">Provider is required.</small>
    </div>

    <div class="flex flex-col gap-1">
        <label for="faretype-select">Select Fare Type</label>
        <p-select
            inputId="faretype-select"
            [options]="fareTypes"
            optionLabel="name"
            optionValue="name"
            appendTo="body"
            formControlName="fareTypeName"
            placeholder="Select Fare Type"
            [disabled]="mode === 'edit'"
            class="w-full"
            [ngClass]="{
                'ng-dirty': submitted && formGroup.get('fareTypeName')?.invalid,
                'ng-invalid': submitted && formGroup.get('fareTypeName')?.invalid
            }"
        />
        <small *ngIf="submitted && formGroup.get('fareTypeName')?.hasError('required')" class="text-red-500">Fare type is required.</small>
    </div>

    <div class="flex flex-col gap-1" formGroupName="titlesByLanguage">
        <label for="title-en">EN</label>
        <input
            id="title-en"
            pInputText
            formControlName="EN"
            placeholder="EN- Text"
            class="w-full"
            maxlength="255"
            [ngClass]="{
                'ng-dirty': submitted && formGroup.get('titlesByLanguage.EN')?.invalid,
                'ng-invalid': submitted && formGroup.get('titlesByLanguage.EN')?.invalid
            }"
        />
        <small *ngIf="submitted && formGroup.get('titlesByLanguage.EN')?.hasError('required')" class="text-red-500"
            >EN title is required.</small
        >
        <small *ngIf="submitted && formGroup.get('titlesByLanguage.EN')?.hasError('maxlength')" class="text-red-500"
            >Max 255 characters.</small
        >
    </div>
    <div class="flex flex-col gap-1" formGroupName="titlesByLanguage">
        <label for="title-de">DE</label>
        <input
            id="title-de"
            pInputText
            formControlName="DE"
            placeholder="DE- Text"
            class="w-full"
            maxlength="255"
            [ngClass]="{
                'ng-dirty': submitted && formGroup.get('titlesByLanguage.DE')?.invalid,
                'ng-invalid': submitted && formGroup.get('titlesByLanguage.DE')?.invalid
            }"
        />
        <small *ngIf="submitted && formGroup.get('titlesByLanguage.DE')?.hasError('required')" class="text-red-500"
            >DE title is required.</small
        >
        <small *ngIf="submitted && formGroup.get('titlesByLanguage.DE')?.hasError('maxlength')" class="text-red-500"
            >Max 255 characters.</small
        >
    </div>
    <div class="flex flex-col gap-1" formGroupName="titlesByLanguage">
        <label for="title-tr">TR</label>
        <input
            id="title-tr"
            pInputText
            formControlName="TR"
            placeholder="TR- Text"
            class="w-full"
            maxlength="255"
            [ngClass]="{
                'ng-dirty': submitted && formGroup.get('titlesByLanguage.TR')?.invalid,
                'ng-invalid': submitted && formGroup.get('titlesByLanguage.TR')?.invalid
            }"
        />
        <small *ngIf="submitted && formGroup.get('titlesByLanguage.TR')?.hasError('required')" class="text-red-500"
            >TR title is required.</small
        >
        <small *ngIf="submitted && formGroup.get('titlesByLanguage.TR')?.hasError('maxlength')" class="text-red-500"
            >Max 255 characters.</small
        >
    </div>
    <div class="flex flex-col gap-1" formGroupName="titlesByLanguage">
        <label for="title-nl">NL</label>
        <input
            id="title-nl"
            pInputText
            formControlName="NL"
            placeholder="NL- Text"
            class="w-full"
            maxlength="255"
            [ngClass]="{
                'ng-dirty': submitted && formGroup.get('titlesByLanguage.NL')?.invalid,
                'ng-invalid': submitted && formGroup.get('titlesByLanguage.NL')?.invalid
            }"
        />
        <small *ngIf="submitted && formGroup.get('titlesByLanguage.NL')?.hasError('required')" class="text-red-500"
            >NL title is required.</small
        >
        <small *ngIf="submitted && formGroup.get('titlesByLanguage.NL')?.hasError('maxlength')" class="text-red-500"
            >Max 255 characters.</small
        >
    </div>

    <div class="flex flex-col gap-1">
        <label for="category-select">Category</label>
        <p-select
            inputId="category-select"
            [options]="categories"
            appendTo="body"
            formControlName="categoryName"
            placeholder="Category"
            class="w-full"
            [ngClass]="{
                'ng-dirty': submitted && formGroup.get('categoryName')?.invalid,
                'ng-invalid': submitted && formGroup.get('categoryName')?.invalid
            }"
        />
        <small *ngIf="submitted && formGroup.get('categoryName')?.hasError('required')" class="text-red-500">Category is required.</small>
    </div>

    <div class="flex flex-col gap-1">
        <label for="status-select">Status</label>
        <p-select
            inputId="status-select"
            [options]="['ACTIVE', 'FORCED', 'PASSIVE']"
            appendTo="body"
            formControlName="status"
            placeholder="Status"
            class="w-full"
            [ngClass]="{
                'ng-dirty': submitted && formGroup.get('status')?.invalid,
                'ng-invalid': submitted && formGroup.get('status')?.invalid
            }"
        />
        <small *ngIf="submitted && formGroup.get('status')?.hasError('required')" class="text-red-500">Status is required.</small>
    </div>

    <div class="flex items-center gap-2">
        <p-checkbox class="leading-none" inputId="mandatory-selection" formControlName="mandatorySelection" [binary]="true" />
        <label for="mandatory-selection">Mandatory Selection</label>
    </div>

    <div class="flex justify-between pt-4">
        <p-button label="Cancel" [text]="true" severity="secondary" (click)="onCancel()"></p-button>
        <p-button [label]="mode === 'add' ? 'Add New' : 'Save'" (click)="onSave()"></p-button>
    </div>
</div>
